import tienDoHoanThanhCv from "../views/report/qlcv/tien-do-hoan-thanh-cv";
import baoCaoTongHopThang from "../views/report/qlcv/bao-cao-tong-hop-thang";
import rankingTongHop from "../views/report/ranking/ranking-bao-cao-tong-hop-thang";
import rankingTrungBinhThang from "../views/report/ranking/ranking-bao-cao-trung-binh";
import baoCaoTinhHinhXuLyVb from "../views/report/incomingDoc/bao-cao-tinh-hinh-xu-ly-vb";

export default [
  {
    path: "/app/:userDeptRoleId/report",
    name: "reportIndex",
    component: () => import("../views/report/index.vue")
  },
  {
    path: "/app/:userDeptRoleId/report/docInBookReport",
    name: "docInBookReport",
    component: () => import("../views/report/docInBookReport.vue")
  },
  {
    path: "/app/:userDeptRoleId/report/vbDocReport",
    name: "vbDocReport",
    component: () => import("../views/report/vbDocReport.vue")
  },
  {
    path: "/app/:userDeptRoleId/report/tienDoHoanThanhCv",
    name: "tienDoHoanThanhCv",
    component: tienDoHoanThanhCv
  },
  {
    path: "/app/:userDeptRoleId/report/baoCaoTongHopThang",
    name: "baoCaoTongHopThang",
    component: baoCaoTongHopThang
  },
  {
    path: "/app/:userDeptRoleId/report/rankingTongHop",
    name: "rankingTongHop",
    component: rankingTongHop
  },
  {
    path: "/app/:userDeptRoleId/report/rankingTrungBinhThang",
    name: "rankingTrungBinhThang",
    component: rankingTrungBinhThang
  },
  {
    path: "/app/:userDeptRoleId/report/tinhHinhXuLyVb",
    name: "tinhHinhXuLyVb",
    component: baoCaoTinhHinhXuLyVb
  },
];



// WEBPACK FOOTER //
// ./src/router/report.js